import React, { useRef, useState } from 'react';

import { ProfileCardProps } from '@/API/models';
import FreePlanRequired, {
  FreePlanRequiredRef,
} from '@/components/Modals/FreePlanReqiured';
import TopUpModal, {
  TopUpModalRef,
} from '@/components/Modals/TopUpModal/TopUpModal';
import { useCurrentUser } from '@/Utils/stripeHooks/useCurrentUser';
import useMediaQuery from '@/Utils/useMediaQuery';

type Props = {
  card: ProfileCardProps;
  className: string;
};

const ProfileCard: React.FC<Props> = ({ card, className }) => {
  const {
    icon,
    title,
    labelPrimary,
    labelSecondary,
    button,
    description,
    infoIcon,
    smallSecondaryLabel,
  } = card;
  const topUpModalRef = useRef<TopUpModalRef>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isSmallScreen = useMediaQuery('(max-width: 500px)');
  const handleShowTooltip = () => {
    if (isMobile) {
      setShowTooltip((prev) => !prev);
    }
  };
  const handleClickOutside = (event) => {
    if (isMobile && !event.target.closest('.profile-info-icon')) {
      setShowTooltip(false);
    }
  };
  const modalRef = useRef<FreePlanRequiredRef>(null);
  const { data: user } = useCurrentUser();
  const handleButtonClick = () => {
    if (button === 'Upgrade') {
      window.location.href = `${window.location.origin}/account/edit#/memberships`;
    } else {
      if (!user?.subscription && user?.role === 'user') {
        modalRef.current?.openModal();
      } else {
        topUpModalRef.current?.openModal();
      }
    }
  };

  return (
    <>
      <div
        className={`grid header-card gap-4 media-915:gap-10 bg-translucent p-10 w-full media-915:rounded-xl relative box-border media-915:shadow-profileCard ${className}`}
        onClick={() => handleClickOutside(event)}
      >
        <div className='self-center basis-auto flex-1 text-center media-915:text-left'>
          <img
            src={icon}
            alt=''
            style={{ maxHeight: isSmallScreen ? '36px' : 'none' }}
          />
        </div>
        <div className='flex flex-col media-915:grid grid-rows-repeat-max-content items-start flex-1 overflow-hidden'>
          <p className='uppercase text-11px media-915:text-14px leading-none font-light text-white pb-5 font-sans whitespace-nowrap w-full relative flex items-center gap-3'>
            {title} {/* TODO: logic for tooltip (waiting for a content)*/}
            {/* {infoIcon && (
            <span className=' profile-info-icon' onClick={handleShowTooltip}>
              <img className='h-14px' src={infoIcon} alt='' />
              {isMobile ? (
                showTooltip && (
                  <p className='tooltips absolute w-full right-0 bottom-12 box-border normal-case whitespace-pre-wrap '>
                    Lorem ipsum dolor sit amet consectetur.
                  </p>
                )
              ) : (
                <p className='tooltips absolute w-full right-0 bottom-12 box-border normal-case whitespace-pre-wrap '>
                  Lorem ipsum dolor sit amet consectetur.
                </p>
              )}
            </span>
          )} */}
          </p>

          <div className='flex flex-wrap w-full gap-2 overflow-hidden pb-4 items-baseline'>
            <p className='uppercase text-18px media-915:text-20px font-normal text-white truncate font-sans whitespace-pre-wrap'>
              {labelPrimary}
            </p>
            {labelSecondary && (
              <p
                className={`uppercase text-18px font-normal text-white truncate font-sans ${smallSecondaryLabel ? 'media-915:text-11px' : 'media-915:text-20px'}`}
              >
                {labelSecondary}
              </p>
            )}
          </div>
          {button && (
            <a
              onClick={handleButtonClick}
              className=' w-full max-w-120px cursor-pointer  box-border btn-secondary border-none h-10'
            >
              {button}
            </a>
          )}
          {description && (
            <p className='text-11px font-normal text-white font-serif'>
              {description}
            </p>
          )}
        </div>
      </div>

      <TopUpModal ref={topUpModalRef} />
      <FreePlanRequired ref={modalRef} />
    </>
  );
};
export default ProfileCard;
